import { Box } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { ChartTimePeriod } from './portfolioChartUtils';
import { CsvXlsxDownloadSelect } from 'packages/common-frontend/components/CsvXlsxDownloadSelect';

export interface CsvDownloadLinkProps {
  dataRows: { [key: string]: any }[];
  headers: { label: string; key: any }[];
  chartTitle: string;
  selectedTimePeriod: ChartTimePeriod;
}

export const PortfolioDownloadCsvLink: React.FC<CsvDownloadLinkProps> = ({
  dataRows,
  headers,
  chartTitle,
  selectedTimePeriod,
}) => {
  const filenamePrefix = `${_.snakeCase(
    chartTitle,
  )}-by-${selectedTimePeriod}.csv`;

  return (
    <Box mt="24px">
      <CsvXlsxDownloadSelect
        dataRows={dataRows}
        headers={headers}
        filenamePrefix={filenamePrefix}
      />
    </Box>
  );
};
